import useTranslation from '../../hooks/useTranslation';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import ErrorButton from 'components/buttons/ErrorButton';
import PrimaryButton from 'components/buttons/PrimaryButton';
import SecondaryButton from 'components/buttons/SecondaryButton';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FormulationReviewModalFooter: FunctionComponent<Props> = ({
    canClear,
    canVerify,
    className = '',
    isBusy,
    isConfirmEnabled,
    onCancel,
    onClear,
    onConfirm,
    onRetry,
    reviewState,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const isLoaded = reviewState.kind === 'loaded';
    const isError = reviewState.kind === 'error';
    const cancelText = canVerify && isLoaded ? t.CANCEL_BUTTON : t.CLOSE_BUTTON;

    return (
        <HorizontalContainer
            className={`${styles.formulationReviewModalFooter} ${className}`}
            testId={testId}>
            <SecondaryButton isDisabled={isBusy} onClick={onCancel} text={cancelText} />

            {isError && <PrimaryButton onClick={onRetry} text={t.RETRY_BUTTON} />}

            {canClear && (
                <ErrorButton isDisabled={isBusy} onClick={onClear} text={t.CLEAR_BUTTON} />
            )}

            {canVerify && isLoaded && (
                <PrimaryButton
                    isDisabled={!isConfirmEnabled}
                    onClick={onConfirm}
                    text={t.CONFIRM_BUTTON}
                />
            )}
        </HorizontalContainer>
    );
};

export default FormulationReviewModalFooter;
